import { createLocalStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/local-storage/index.tsx';
import type {
	WebStorageProvider,
	WebStorageProviderNew,
} from '@jira/platform__browser-storage-providers/src/types.tsx';

export const LOG_LOCATION = 'issue.issue-context-service';
// eslint-disable-next-line jira/web-storage/no-export-browser-storage-provider
export const localStorage: WebStorageProvider | WebStorageProviderNew =
	createLocalStorageProvider('jira_issue_view');
export const VIEW_MODE_STORAGE_KEY = 'view-mode';
